/* ============================================
   Scroll Reveal (IntersectionObserver)
   ============================================ */

(function () {
    'use strict';

    function initScrollReveal() {
        var reveals = document.querySelectorAll('.reveal');
        if (!reveals.length) return;

        // Stagger delay for sibling grid items
        var parents = {};
        reveals.forEach(function (el) {
            var parent = el.parentElement;
            if (!parent) return;
            var key = parent.className;
            if (!parents[key]) parents[key] = [];
            parents[key].push(el);
        });

        Object.keys(parents).forEach(function (key) {
            parents[key].forEach(function (el, i) {
                el.style.transitionDelay = (i * 0.08) + 's';
            });
        });

        // Use a single observer for all elements
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    // Cancel the CSS fallback animation
                    entry.target.style.animation = 'none';
                    // Small delay to ensure the animation property is cleared
                    requestAnimationFrame(function () {
                        entry.target.classList.add('visible');
                    });
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0,
            rootMargin: '50px'
        });

        reveals.forEach(function (el) {
            observer.observe(el);
        });
    }

    // Wait for DOMContentLoaded + next frame to ensure layout is complete
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            // Double rAF ensures layout is complete
            requestAnimationFrame(function () {
                requestAnimationFrame(initScrollReveal);
            });
        });
    } else {
        requestAnimationFrame(function () {
            requestAnimationFrame(initScrollReveal);
        });
    }
})();
